import * as React from 'react';

const SvgArrowsUpDownOutlined = (props) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		fill="none"
		viewBox="0 0 25 25"
		width="1em"
		height="1em"
		{...props}
	>
		<path
			fill="#60636B"
			fillRule="evenodd"
			d="M2.43842 7.6352C2.14553 7.92809 2.14553 8.40296 2.43842 8.69586C2.73131 8.98875 3.20619 8.98875 3.49908 8.69586L6.54804 5.6469C6.61104 5.5839 6.71875 5.62852 6.71875 5.71761L6.71875 17.1655C6.71875 17.5797 7.05454 17.9155 7.46875 17.9155C7.88296 17.9155 8.21875 17.5797 8.21875 17.1655L8.21875 5.71761C8.21875 5.62852 8.32646 5.5839 8.38946 5.6469L11.4384 8.69586C11.7313 8.98875 12.2062 8.98875 12.4991 8.69586C12.792 8.40296 12.792 7.92809 12.4991 7.6352L7.99908 3.1352C7.85843 2.99454 7.66766 2.91553 7.46875 2.91553C7.26984 2.91553 7.07907 2.99454 6.93842 3.1352L2.43842 7.6352ZM12.4991 16.6352C12.2062 16.3423 11.7313 16.3423 11.4384 16.6352C11.1455 16.9281 11.1455 17.403 11.4384 17.6959L15.9384 22.1959C16.2313 22.4888 16.7062 22.4888 16.9991 22.1959L21.4991 17.6959C21.792 17.403 21.792 16.9281 21.4991 16.6352C21.2062 16.3423 20.7313 16.3423 20.4384 16.6352L17.3895 19.6842C17.3265 19.7472 17.2187 19.7025 17.2187 19.6134L17.2187 8.16553C17.2187 7.75131 16.883 7.41553 16.4687 7.41553C16.0545 7.41553 15.7187 7.75131 15.7187 8.16553L15.7187 19.6134C15.7187 19.7025 15.611 19.7472 15.548 19.6842L12.4991 16.6352Z"
			clipRule="evenodd"
		/>
	</svg>
);
export default SvgArrowsUpDownOutlined;

